<template>
  <el-row>
    <el-upload
      class="upload-demo"
      :action="action"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :before-remove="beforeRemove"
      multiple
      :accept="accept"
      :drag="drag"
      :limit="limit"
      :headers="headers"
      :on-exceed="handleExceed"
      :file-list="fileList || []">
      <template v-if="drag">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">{{title}}</div>
      </template>
      <template v-else>
        <el-button size="small" type="primary">点击上传</el-button>
      </template>
      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
    </el-upload>
  </el-row>
</template>

<script>

export default {
  name: 'UploadFiles',
  props: {
    limit:{
      type: Number,
      default: function() {
        return 100;
      }
    },
    fileLists:{
      type: Array,
      default: function() {
        return []
      }
    },
    drag:{
      type: Boolean,
      default: function() {
        return false
      }
    },
    isPdf:{ //是否转换成pdf
      type: Boolean,
      default: true
    },
    accept:{
      type: String,
      default: function() {
        return "";
      }
    },
    title:{
      type: String,
      default: function() {
        return "上传文件，仅支持PDF格式";
      }
    }
  },
  data() {
    return {
      headers: {
        token: this.$getToken()
      },
      action: this.$baseUrl + '/api/file/update.do',
      fileList: [],
      loading:null
    }
  },
  created() {
    for(let i in this.fileLists){
      this.fileList.push({
        name:this.fileLists[i].name || this.fileLists[i].fileName,
        url:this.fileLists[i].url || this.fileLists[i].fileUrl
      })
    }
  },
  methods: {
    // 上传之前，可以做一些校验
    beforeUpload(file) {
      if(!this.$isEmpty(this.accept)){
        const fileName = file.name;
        const fileType = fileName.substring(fileName.lastIndexOf('.'));
        // jpeg,.png,.jpg,.bmp,.gif
        if (this.accept.toUpperCase().indexOf(fileType.toUpperCase()) < 0) {
          this.$message.warning("文件类型错误，请重新上传！")
          return false;
        }
      }
      const isLt5M = file.size / 1024 / 1024 < 500
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 500MB!')
      }else{
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      return isLt5M;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('onSuccess', this.fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      //return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 上传成功后的回调
    handleSuccess(res, file) {
      this.loading.close();
      if(res.code == 0){
        let name = res.data.nameFormat;
        if(!this.$isEmpty(res.data.cvPDFUrl) && this.isPdf){
          name = res.data.name +".pdf";
        }
        this.fileList.push({
          name:name,
          url:!this.$isEmpty(res.data.cvPDFUrl) && this.isPdf?res.data.cvPDFUrl:res.data.url
        });
        this.$emit('onSuccess', this.fileList);
      }else{
        this.$message.error(res.msg);
      }
      console.log('success', this.fileList)
    },
    // 上传失败后的回调
    onError() {
      this.loading.close();
    },
  }
}
</script>

<style scoped>
.image-upload ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image-upload ::v-deep .el-upload:hover {
  border-color: #409EFF;
}
.image-upload-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFiles/index.vue